import { Message } from 'element-ui';
/**
 * 用于测试环境的打印log功能
 * TODO: product环境屏蔽该功能
 */
function log(...args) {
  let result = args.map(one=>{
    if(one === null) return 'null'
    if(one === undefined) return 'undefined'
    return one.toString()
    })
    .join(' ')
  console.log(...args)
  Message({message: result})
}

export default log



// WEBPACK FOOTER //
// ./src/util/log.js